<template>
  <div id="newExperienceManager">
    <!-- Title Tab -->
    <j-headful
      v-if="detailFormUi && detailFormUi.name"
      :title="detailFormUi.name"
    />

    <!-- Header -->
    <div
      :class="{ 'header-page-long' : !is_sidebar_minimized }"
      class="header-page"
    >
      <div class="wrap-left-header">
        <img
          class="back-to-list"
          src="@/assets/icon/arrow-left.svg"
          @click="$router.push('/experience-manager')"
        >
        <img src="@/assets/icon-sidebar/experience-manager.svg">

        <div
          v-click-outside="updateTitleFormUi"
          :class="{'header-item--active': isEditTitleActive}"
          class="header-item"
        >
          <div class="badge-type-ui">{{ isMultipleForm ? 'Multiple' : 'Single' }}</div>
          <span>{{ detailFormUi ? detailFormUi.id : '' }}</span>
          <div class="line"/>
          <div
            class="title-wrap"
          >
            <h3
              :style="isEditTitleActive ? {'display': 'none'} : {}"
              class="title-input-label"
              @dblclick="editTitleFormUi"
            >
              {{ titleFormUi }}
              <div class="tooltip-component">
                Double Click to edit this Title
              </div>
            </h3>
            <input
              ref="titleInput"
              :style="isEditTitleActive ?
                { 'width': `${titleFormUi.length * 7.5}px`,
                  'display': 'inline-block'} : {}"
              v-model="titleFormUi"
              type="text"
              class="title-input"
              @keyup.enter="updateTitleFormUi"
            >
          </div>
        </div>

        <div
          v-if="header && header.title"
          class="header-item header-item-source"
        >
          <div class="data-source">
            <img src="@/assets/icon-sidebar/data-manager.svg">
            <div class="data-source-info">
              <p class="data-source-name">
                {{ header ? header.title : '&nbsp;' }}
              </p>
              <p class="data-source-type">
                {{ detailFormUi ? reformatTextDataType(detailFormUi.type) : '' }}
              </p>
            </div>
            <div
              v-if="detailFormUi && detailFormUi.type === 'form'"
              class="open-tab">
              <img
                src="@/assets/icon-sidebar/open-tab.svg"
                @click="openTable()">
              <div class="tooltip-component">
                Open new tab
              </div>
            </div>
          </div>
        </div>
      </div>

      <i
        id="popover-config-menu"
        class="fa fa-ellipsis-v fa-lg popover-config"
        @click="configPopoverShow = true"
      />

      <!-- Config Popover -->
      <b-popover
        v-click-outside="closePopover"
        :show.sync="configPopoverShow"
        target="popover-config-menu"
        triggers="click"
        container="header-page"
        placement="left">
        <div
          class="form-ui-opt"
          @click="openCodeForm">
          View Code
        </div>
        <div
          class="form-ui-opt"
          @click="deleteFormUi">
          Delete
        </div>
        <!-- <div
          class="form-ui-opt"
          @click="BackToV1">
          Back to Old JxM
        </div> -->
      </b-popover>
    </div>

    <!-- Content -->
    <div class="form-ui-content">
      <div
        :class="{ 'body-content-long' : !is_sidebar_minimized }"
        class="body-content"
      >
        <!-- List View Page -->
        <list-view
          :form-detail="detailFormUi"
          :section-general="sectionGeneral"
          :section-view="sectionView"
          :menu-active="formMenuActive"
          @change-view="changeFormMenu"
        />

        <!-- Fields Library -->
        <field-library
          v-if="formMenuActive === 'create' || formMenuActive === 'detail'"
          :menu-active="formMenuActive"
        />

        <!-- Content View Page -->
        <j-experience-manager-view-content
          v-if="showComponent"
          :form-detail="detailFormUi"
          :form-data="detailFormData"
          :dataset="detailDataset"
          :menu="formMenuActive"
          :is-multiple-form="isMultipleForm"
        />
      </div>
    </div>

    <!-- Modal View Code -->
    <b-modal
      ref="appCodeFormDataModal"
      class="mod-form modal-code-form-data"
      centered>
      <modal-view-code
        v-if="showModalViewCode"
        :json-data="jsonData"
        :view-code="viewCode"
        @close-modal="closeCodeForm"
      />
    </b-modal>
  </div>
</template>

<script>
/* eslint-disable no-nested-ternary, max-len, no-console */
import ClickOutside from 'vue-click-outside';
import { mapActions, mapState, mapMutations } from 'vuex';
import ModalViewCode from '@/views/experience-manager-v2/popup/ModalViewCode';
import ListView from '@/views/experience-manager-v2/partials/ListView';
import FieldLibrary from '@/views/experience-manager-v2/partials/FieldLibrary';
import jExperienceManagerViewContent from '@/views/experience-manager-v2/jExperienceManagerViewContent';

export default {
  directives: {
    ClickOutside,
  },

  components: {
    ModalViewCode,
    ListView,
    FieldLibrary,
    jExperienceManagerViewContent,
  },

  data() {
    return {
      detailFormUi: null,
      detailFormData: null,
      detailDataset: null,
      sectionGeneral: [],
      sectionView: [],
      formMenu: [
        {
          id: 'information',
          name: 'Information',
          section: 'general',
          icon: 'info',
          isWorkflow: false,
          isDataset: true,
        },
        {
          id: 'table',
          key: 'table_view',
          name: 'Table',
          section: 'view',
          icon: 'table',
          isWorkflow: false,
          isDataset: true,
        },
        {
          id: 'table-requestor',
          key: 'table_requester_view',
          name: 'Table Requestor',
          section: 'view',
          icon: 'table',
          isWorkflow: true,
          isDataset: false,
        },
        {
          id: 'table-approver',
          key: 'table_approver_view',
          name: 'Table Approver',
          section: 'view',
          icon: 'table',
          isWorkflow: true,
          isDataset: false,
        },
        {
          id: 'list',
          key: 'list_view',
          name: 'List',
          section: 'view',
          icon: 'list',
          isWorkflow: false,
          isDataset: true,
        },
        {
          id: 'list-requestor',
          key: 'list_requester_view',
          name: 'List Requestor',
          section: 'view',
          icon: 'list',
          isWorkflow: true,
          isDataset: false,
        },
        {
          id: 'list-approver',
          key: 'list_approver_view',
          name: 'List Approver',
          section: 'view',
          icon: 'list',
          isWorkflow: true,
          isDataset: false,
        },
        {
          id: 'calendar',
          key: 'calendar_view',
          name: 'Calendar',
          section: 'view',
          icon: 'calendar',
          isWorkflow: false,
          isDataset: false,
        },
        {
          id: 'create',
          key: 'create_view',
          name: 'Create',
          section: 'view',
          icon: 'create',
          isWorkflow: false,
          isDataset: false,
        },
        {
          id: 'detail',
          key: 'detail_view',
          name: 'Detail',
          section: 'view',
          icon: 'detail',
          isWorkflow: false,
          isDataset: true,
        },
        {
          id: 'import',
          key: 'import_view',
          name: 'Import',
          section: 'view',
          icon: 'import',
          isWorkflow: false,
          isDataset: false,
        },
        {
          id: 'export',
          key: 'export_view',
          name: 'Export',
          section: 'view',
          icon: 'export',
          isWorkflow: false,
          isDataset: true,
        },
      ],
      formMenuTab: [],
      formMenuActive: 'information',
      configPopoverShow: false,
      showModalViewCode: false,
      jsonData: '',
      viewCode: '',
      titleFormUi: '',
      isEditTitleActive: false,
    };
  },

  computed: {
    ...mapState('jStoreFormUi', ['form_detail', 'multiple_form_detail', 'form_data_detail', 'changed_tab', 'changes_value_view']),
    ...mapState('jStoreSetting', ['is_sidebar_minimized']),

    showComponent() {
      if (this.detailFormUi ? this.detailFormUi.form_data_id : null) {
        return this.detailFormData ? this.detailFormData : this.detailFormUi;
      } else if (this.detailFormUi ? this.detailFormUi.data_source && this.detailFormUi.data_source.dataset && this.detailFormUi.data_source.dataset.dataset_id : null) {
        return this.detailDataset ? this.detailDataset : this.detailFormUi;
      }
      return this.detailFormUi;
    },

    isMultipleForm() {
      const url = window.location.href;
      return !!url.includes('multiple-experience-manager');
    },

    header() {
      if (this.detailFormUi && this.detailFormUi.form_data_id) {
        return {
          title: this.detailFormData ? this.detailFormData.name : '',
          columns: this.listColumns(this.detailFormData),
        };
      } else if (this.detailFormUi && this.detailFormUi.type === 'external_url') {
        // eslint-disable-next-line
        const dataColumn = this.detailFormUi && this.detailFormUi.data_source ? this.detailFormUi.data_source.external_url : null;
        return {
          title: 'External API',
          columns: this.listColumns(dataColumn),
        };
      } else if (this.detailFormUi && this.detailFormUi.type === 'dataset') {
        return {
          title: this.detailDataset ? this.detailDataset.name : '',
          columns: this.listColumnsDataset(this.detailDataset),
        };
      }
      return {
        title: 'Data Source Not Selected',
        columns: [],
      };
    },
  },

  watch: {
    form_detail(val) {
      if (val.length > 0) {
        this.detailFormUi = val[0];
        if (this.detailFormUi.form_data_id) {
          const dataFilterForm = {
            id: [this.detailFormUi.form_data_id],
          };
          const paramForm = {
            limit: 0,
            page: 1,
            filter: JSON.stringify(dataFilterForm),
          };
          this.actionGetDetailFormData(paramForm);
        } else if (this.detailFormUi.data_source && this.detailFormUi.data_source.dataset && this.detailFormUi.data_source.dataset.dataset_id) {
          const req = {
            id: this.detailFormUi.data_source.dataset.dataset_id,
          };
          this.getDetailDatasetByGroup(req).then((res) => {
            this.detailDataset = res.data || null;
            this.sectionGeneral = this._.filter(this.formMenu, { section: 'general', isDataset: true });
            this.sectionView = this._.filter(this.formMenu, { section: 'view', isDataset: true });
          });
        } else {
          this.clearFormDataDetail();
          this.sectionGeneral = this._.filter(this.formMenu, { section: 'general' });
          this.sectionView = this._.filter(this.formMenu, { section: 'view', isWorkflow: false });
        }

        // set title
        this.titleFormUi = this.detailFormUi.name;
      }
    },

    multiple_form_detail(val) {
      if (val.length > 0) {
        this.detailFormUi = val[0];
        if (this.detailFormUi.form_data_id) {
          const dataFilterForm = {
            id: [this.detailFormUi.form_data_id],
          };
          const paramForm = {
            limit: 0,
            page: 1,
            filter: JSON.stringify(dataFilterForm),
          };
          this.actionGetDetailFormData(paramForm);
        } else {
          this.clearFormDataDetail();
          this.sectionGeneral = this._.filter(this.formMenu, { section: 'general' });
          this.sectionView = this._.filter(this.formMenu, { section: 'view', isWorkflow: false });
        }

        this.formMenuTab = [];
        // if (this.detailFormUi.tabs) {
        //   this.detailFormUi.tabs.forEach((e) => {
        //     this.addMenuTab(e);
        //   });
        // } else {
        //   this.addMenuTab(null);
        // }

        // set title
        this.titleFormUi = this.detailFormUi.name;
      }
    },

    form_data_detail(val) {
      if (val.length > 0) {
        this.detailFormData = val[0];
        if (this.detailFormData.is_use_workflow) {
          this.sectionGeneral = this._.filter(this.formMenu, { section: 'general' });
          this.sectionView = this._.filter(this.formMenu, { section: 'view' });
        } else {
          this.sectionGeneral = this._.filter(this.formMenu, { section: 'general' });
          this.sectionView = this._.filter(this.formMenu, { section: 'view', isWorkflow: false });
        }
      }
    },
  },

  async created() {
    this.setChangesValueView(false);
    const dataFilter = {
      id: [this.$route.params.id],
    };
    const param = {
      limit: 0,
      page: 1,
      filter: JSON.stringify(dataFilter),
    };
    if (this.isMultipleForm) {
      await this.actionGetDetailMultiForm(param);
    } else {
      await this.actionGetDetailForm(param);
    }
    setTimeout(() => {
      this.setSidebarMinimized(false);
    }, 300);

    localStorage.setItem('jxm_version', 'v2');
  },

  methods: {
    ...mapActions('jStoreFormUi', ['actionGetDetailForm', 'actionGetDetailMultiForm', 'actionGetDetailFormData', 'actionDeleteForm', 'actionDeleteMultiForm', 'actionSetForm', 'actionSetMultiForm']),
    ...mapActions('jStoreJoana', ['getDetailDatasetByGroup']),
    ...mapActions('jStoreNotificationScreen', ['toggleProblem']),
    ...mapMutations('jStoreFormUi', ['setChangesValueView', 'clearFormDataDetail']),
    ...mapMutations('jStoreSetting', ['setSidebarMinimized']),

    listColumns(val) {
      if (val && val.columns) {
        return Object.keys(val.columns);
      }
      return [];
    },

    listColumnsDataset(val) {
      if (val && val.column) {
        return Object.keys(val.column);
      }
      return [];
    },

    openCodeForm() {
      this.configPopoverShow = false;
      const id = this.detailFormUi.id;
      const companyId = this.detailFormUi.company_id;
      const createdBy = this.detailFormUi.created_by;
      const updatedBy = this.detailFormUi.updated_by;
      const createdAt = this.detailFormUi.created_at;
      const updatedAt = this.detailFormUi.updated_at;
      const code = this.detailFormUi;

      delete code.id;
      delete code.created_by;
      delete code.updated_by;
      delete code.created_at;
      delete code.updated_at;
      delete code.company_id;

      this.jsonData = JSON.stringify(code, null, 4);
      this.viewCode = JSON.stringify(code, null, 4);
      this.$refs.appCodeFormDataModal.show();
      this.showModalViewCode = true;

      this.detailFormUi.id = id;
      this.detailFormUi.company_id = companyId;
      this.detailFormUi.created_by = createdBy;
      this.detailFormUi.updated_by = updatedBy;
      this.detailFormUi.created_at = createdAt;
      this.detailFormUi.updated_at = updatedAt;
    },

    closeCodeForm() {
      this.jsonData = '';
      this.$refs.appCodeFormDataModal.hide();
      this.showModalViewCode = false;
    },

    deleteFormUi() {
      this.configPopoverShow = false;
      const text = `Are you sure to delete ${this.detailFormUi.name}?`;

      this.$swal({
        title: 'Delete',
        text,
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Delete',
        confirmButtonColor: '#D2232A',
        cancelButtonColor: '#D2232A',
        titleColor: '#D2232A',
      }).then(async (result) => {
        if (result.value) {
          const params = {
            id: this.detailFormUi.id,
          };
          let res;
          if (!this.isMultipleForm) {
            res = await this.actionDeleteForm(params);
          } else {
            res = await this.actionDeleteMultiForm(params);
          }

          if (!res.error) {
            this.$router.push('/experience-manager');
          }
        }
      });
    },

    BackToV1() {
      if (this.isMultipleForm) this.$router.push(`/multiple-form-ui/update/${this.$route.params.id}`);
      else this.$router.push(`/form-ui/update/${this.$route.params.id}`);

      localStorage.setItem('jxm_version', 'v1');
    },

    changeFormMenu(view) {
      if (this.changes_value_view) {
        const text = 'Are you sure want to move without save your changes ?';
        this.$swal({
          title: 'Warning',
          text,
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes',
          confirmButtonColor: '#D2232A',
          cancelButtonColor: '#D2232A',
          titleColor: '#D2232A',
        }).then(async (result) => {
          if (result.value) {
            this.formMenuActive = view;
            this.setChangesValueView(false);
          }
        });
      } else {
        this.formMenuActive = view;
      }
    },

    reformatTextDataType(type) {
      let dataType = '';

      if (type === 'form') {
        dataType = 'Data Manager';
      } else if (type === 'external_url') {
        dataType = 'External API';
      } else {
        dataType = type;
      }

      return dataType;
    },

    closePopover() {
      this.configPopoverShow = false;
    },

    editTitleFormUi() {
      this.isEditTitleActive = true;

      setTimeout(() => {
        this.$refs.titleInput.focus();
      }, 100);
    },

    updateTitleFormUi() {
      if (this.isEditTitleActive) {
        if (this.titleFormUi && this.titleFormUi === this.detailFormUi.name) {
          this.isEditTitleActive = false;
        } else if (this.titleFormUi) {
          this.isEditTitleActive = false;
          const params = this._.cloneDeep(this.detailFormUi);
          params.name = this.titleFormUi;
          this.submitForm(params);
        } else {
          this.toggleProblem('Title cannot be empty');
        }
      }
    },

    async submitForm(params) {
      const res = this.isMultipleForm ? await this.actionSetMultiForm(params) : await this.actionSetForm(params);

      if (!res.error) {
        this.setChangesValueView(false);
        const dataFilter = {
          id: [this.$route.params.id],
        };
        const param = {
          limit: 0,
          page: 1,
          filter: JSON.stringify(dataFilter),
        };
        if (!this.isMultipleForm) {
          await this.actionGetDetailForm(param);
        } else {
          await this.actionGetDetailMultiForm(param);
        }
      }
    },

    openTable() {
      const groupId = this.detailFormUi.tablegroup_id;
      const tableId = this.detailFormUi.form_data_id;
      const url = `${window.location.origin}/#/form-data/table/${groupId}/${tableId}`;
      window.open(url, '_blank');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/experience-manager-v2/jExperienceManager.vue